import React from "react";
import { withServiceWorkerUpdater } from "@3m1/service-worker-updater";

const Updater = (props) => {
  const { newServiceWorkerDetected, onLoadNewServiceWorkerAccept } = props;
  return newServiceWorkerDetected ? (
    <>
      New version detected.
      <button
        onClick={onLoadNewServiceWorkerAccept}
        className="btn btn-secondary mb-2"
      >{`Refresh & Update`}</button>
    </>
  ) : (
    <>{console.log("No update available - latest version detected.")}</>
  ); // If no update is available, render nothing
};

export default withServiceWorkerUpdater(Updater);
